import React, { useEffect, useState } from "react";
import './App.css';
import { Link, useNavigate } from "react-router";
import NavBar from "./components/layout/NavBar";
import Footer from "./components/layout/Footer";
import novoEventoService from "./services/Eventos/NovoEventoService";
import { Skeleton } from "./components/ui";
import {
    Calendar,
    Activity,
    PlusCircle,
    BarChart3,
    Download,
    ChevronRight,
    Zap,
    Inbox
} from "lucide-react";

function App() {
    const navigate = useNavigate();
    const [eventosOrganizador, setEventosOrganizador] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const userId = sessionStorage.getItem('brv-user-id');
        const eventoService = new novoEventoService();

        const carregarDados = async () => {
            try {
                // 1. Busca métricas do dashboard
                await eventoService.getDashOrganizador(userId);
            } catch (error) {
                console.error("Erro ao carregar dados do dashboard:", error);
            }

            try {
                // 2. Busca lista de todos os eventos do organizador
                const resEventos = await eventoService.getEventoPorOrganizador(userId);
                if (resEventos && resEventos.ok) {
                    const datEventos = await resEventos.json();
                    if (Array.isArray(datEventos)) {
                        setEventosOrganizador(datEventos);
                    }
                }
            } catch (error) {
                console.error("Erro ao carregar eventos do organizador:", error);
            } finally {
                setLoading(false);
            }
        };

        carregarDados();
    }, []);

    const userName = sessionStorage.getItem('brv-user') || 'Leandro';

    const formatDate = (value) => {
        if (!value) return "—";
        if (typeof value === "string") {
            const cleanStr = value.split("T")[0];
            const parts = cleanStr.split("-");
            if (parts.length === 3) {
                const [year, month, day] = parts;
                return `${day.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`;
            }
        }
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return value;
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = String(date.getFullYear());
        return `${day}/${month}/${year}`;
    };

    const getBadgeClass = (status) => {
        const s = String(status || '').toLowerCase();
        if (s.includes('abert')) {
            return 'badge-status badge-open';
        }
        if (s.includes('prepar') || s.includes('criado')) {
            return 'badge-status badge-prep';
        }
        return 'badge-status badge-closed';
    };

    const getStatusDotColor = (status) => {
        const s = String(status || '').toLowerCase();
        if (s.includes('abert')) {
            return '#8AE600';
        }
        if (s.includes('prepar') || s.includes('criado')) {
            return '#60A5FA';
        }
        return '#64748B';
    };

    const handleExportInscritos = () => {
        alert("Exportando lista de inscritos...");
    };

    return (
        <div className="App bg-[#0A0B0D] min-h-screen text-urb-text">
            <header>
                <NavBar />
            </header>

            <main className="dash-container px-4 sm:px-6 py-6 flex flex-col gap-6">
                {/* Header de Boas-Vindas */}
                <div className="flex flex-col gap-1">
                    <div className="flex items-center gap-2">
                        <h1 className="text-2xl sm:text-3xl font-bold m-0 text-white tracking-tight">
                            Bem-vindo, {userName}
                        </h1>
                        <Activity className="w-6 h-6 inline text-urb-primary" />
                    </div>
                    <p className="m-0 text-sm sm:text-base font-normal text-urb-text-secondary">
                        Aqui está o essencial do seu organizador.
                    </p>
                </div>

                {/* Seção Inferior: Próximos Eventos e Ações Rápidas */}
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
                    {/* Próximos eventos (Coluna da Esquerda - 8 colunas) */}
                    <div className="lg:col-span-8">
                        <div className="dash-card p-5 sm:p-6 flex flex-col justify-between h-full bg-urb-card border border-urb-border rounded-2xl">
                            <div>
                                <div className="flex items-center gap-2 mb-4">
                                    <Calendar className="w-5 h-5 text-urb-primary" />
                                    <h2 className="text-base sm:text-lg font-bold m-0 text-white">
                                        Próximos eventos
                                    </h2>
                                </div>

                                {loading ? (
                                    /* Skeleton de Carregamento */
                                    <div className="flex flex-col gap-3 py-2">
                                        {[1, 2, 3, 4].map((i) => (
                                            <div 
                                                key={i} 
                                                className="flex items-center justify-between py-3 border-b border-[#1A1D24]"
                                            >
                                                <div className="flex items-center gap-2 w-1/3">
                                                    <Skeleton shape="circle" size="8px" />
                                                    <Skeleton width="75%" height="16px" />
                                                </div>
                                                <Skeleton width="16%" height="14px" />
                                                <Skeleton width="20%" height="16px" />
                                                <Skeleton width="18%" height="22px" borderRadius="16px" />
                                                <Skeleton width="10%" height="14px" />
                                            </div>
                                        ))}
                                    </div>
                                ) : eventosOrganizador.length === 0 ? (
                                    /* Estado Vazio (Sem Dados) */
                                    <div className="flex flex-col items-center justify-center py-8 text-center gap-3">
                                        <div className="w-14 h-14 rounded-full bg-[#16181E] border border-[#232731] flex items-center justify-center">
                                            <Inbox className="w-6 h-6 text-urb-text-muted" />
                                        </div>
                                        <div className="flex flex-col gap-1">
                                            <span className="text-sm font-semibold text-white">Nenhum evento encontrado</span>
                                            <span className="text-xs text-urb-text-muted">
                                                Você ainda não possui eventos cadastrados.
                                            </span>
                                        </div>
                                        <button
                                            type="button"
                                            onClick={() => navigate('/eventos')}
                                            className="cursor-pointer text-xs font-semibold py-2 px-3 rounded-lg transition-colors bg-urb-primary/10 text-urb-primary border border-urb-primary/30 hover:bg-urb-primary/20"
                                        >
                                            + Criar primeiro evento
                                        </button>
                                    </div>
                                ) : (
                                    /* Tabela de Eventos Reais */
                                    <div className="overflow-x-auto">
                                        <table className="dash-table">
                                            <thead>
                                                <tr>
                                                    <th className="w-4/12">Evento</th>
                                                    <th className="w-2/12">Data</th>
                                                    <th className="w-2/12 text-center">Lote / Valor</th>
                                                    <th className="w-2/12 text-center">Status</th>
                                                    <th className="w-2/12 text-right">Inscritos</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {eventosOrganizador.map((ev, index) => (
                                                    <tr key={ev.id_corrida || ev.id || index}>
                                                        <td>
                                                            <div className="flex items-center gap-2">
                                                                <span 
                                                                    className="w-1.5 h-1.5 rounded-full shrink-0 inline-block"
                                                                    style={{ 
                                                                        backgroundColor: getStatusDotColor(ev.status_evento || ev.status),
                                                                    }} 
                                                                />
                                                                <span className="font-medium text-white hover:text-urb-primary transition-colors">
                                                                    {ev.nome_corrida || ev.nome}
                                                                </span>
                                                            </div>
                                                        </td>
                                                        <td className="text-urb-text-secondary">
                                                            {formatDate(ev.data_evento || ev.data)}
                                                        </td>
                                                        <td className="text-center">
                                                            {ev.lote_ativo ? (
                                                                <div className="flex flex-col items-center gap-0.5">
                                                                    <span className="text-xs font-semibold text-white">{ev.lote_ativo.nome_lote}</span>
                                                                    <span className="text-xs font-bold text-urb-primary">
                                                                        R$ {Number(ev.lote_ativo.valor).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                    </span>
                                                                </div>
                                                            ) : ev.lotes && ev.lotes.length > 0 ? (
                                                                <span className="text-xs text-urb-text-secondary">
                                                                    {ev.lotes.length} lote{ev.lotes.length > 1 ? 's' : ''}
                                                                </span>
                                                            ) : (
                                                                <span className="text-xs text-urb-text-muted">
                                                                    —
                                                                </span>
                                                            )}
                                                        </td>
                                                        <td className="text-center">
                                                            <span className={getBadgeClass(ev.status_evento || ev.status)}>
                                                                {ev.status_evento || ev.status || "Em preparação"}
                                                            </span>
                                                        </td>
                                                        <td className="text-right text-slate-300 font-medium">
                                                            {ev.total_inscritos ?? ev.qtd_inscritos ?? ev.inscritos ?? "—"}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>

                            <div className="mt-5 pt-3 border-t border-urb-border/50">
                                <Link 
                                    to="/eventos" 
                                    className="no-underline inline-flex items-center gap-1 text-sm font-semibold text-urb-primary hover:opacity-80 transition-opacity"
                                >
                                    <span>Ver todos os eventos</span>
                                    <ChevronRight className="w-4 h-4" />
                                </Link>
                            </div>
                        </div>
                    </div>

                    {/* Ações Rápidas (Coluna da Direita - 4 colunas) */}
                    <div className="lg:col-span-4">
                        <div className="dash-card p-5 sm:p-6 flex flex-col h-full bg-urb-card border border-urb-border rounded-2xl">
                            <div className="flex items-center gap-2 mb-4">
                                <Zap className="w-5 h-5 text-urb-primary" />
                                <h2 className="text-base sm:text-lg font-bold m-0 text-white">
                                    Ações rápidas
                                </h2>
                            </div>

                            <div className="flex flex-col gap-3">
                                {/* Ação 1: Criar evento */}
                                <button
                                    type="button"
                                    onClick={() => navigate('/eventos')}
                                    className="quick-action-btn"
                                >
                                    <div className="flex items-center gap-3">
                                        <PlusCircle className="w-5 h-5 text-urb-primary" />
                                        <span className="font-medium text-sm text-white">Criar evento</span>
                                    </div>
                                    <ChevronRight className="w-4 h-4 text-urb-text-muted" />
                                </button>

                                {/* Ação 2: Ver financeiro */}
                                <button
                                    type="button"
                                    onClick={() => navigate('/financeiro')}
                                    className="quick-action-btn"
                                >
                                    <div className="flex items-center gap-3">
                                        <BarChart3 className="w-5 h-5 text-urb-primary" />
                                        <span className="font-medium text-sm text-white">Ver financeiro</span>
                                    </div>
                                    <ChevronRight className="w-4 h-4 text-urb-text-muted" />
                                </button>

                                {/* Ação 3: Exportar inscritos */}
                                <button
                                    type="button"
                                    onClick={handleExportInscritos}
                                    className="quick-action-btn"
                                >
                                    <div className="flex items-center gap-3">
                                        <Download className="w-5 h-5 text-urb-primary" />
                                        <span className="font-medium text-sm text-white">Exportar inscritos</span>
                                    </div>
                                    <ChevronRight className="w-4 h-4 text-urb-text-muted" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    );
}

export default App;
